import { channels } from "@/mocks/gossip";

export default function Channels() {
  return (
    <section id="channels" className="scroll-mt-20 bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-600">
              <i className="ri-compass-3-line text-sm" />
              瓜田寻路
            </p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-900 md:text-3xl">频道目录，按口味进场</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              综艺、红毯、影视、直播……想吃哪口进哪区，热门频道实时人气都在线上。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((c) => (
            <a
              key={c.id}
              href="#hot"
              className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-primary-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-primary-600 transition-colors group-hover:bg-primary-100">
                <i className={`${c.icon} text-2xl`} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="truncate text-sm font-bold text-foreground-900">{c.name}</span>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-700">
                    {c.count} 热度
                  </span>
                </span>
                <span className="mt-0.5 block truncate text-xs text-foreground-500">{c.desc}</span>
              </span>
              <i className="ri-arrow-right-s-line text-xl text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-primary-600" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}